import api from '@/client/core/api'
import { GetTagsQuery, TagListResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts/tags
 */
export async function getTwBenchmarkTags(query: GetTagsQuery): Promise<TwBenchmarkApiResult<TagListResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<TagListResponse>>('/twitter_benchmark_campaign_posts/tags', {
    params: query
  })

  return handleApiResponse<TagListResponse>(response)
}
